module.exports = __webpack_public_path__ + "static/media/map.062b76b9.png";